<script>
import XTable from "@/components/table/XTable.vue";
import { getFirstAndLastDayOfMonth, accAdd } from '@/vue/util/tool'
import {
  communitynameQuery,
  departmentFind, employeeQuery,
  queryCollectedStatistics, roleUpdate
} from "../../api/manageCenter";
import {mapGetters} from "vuex";

function fix(a,b) {
  return `${a||0}/${b||0}`;
}

export default {
  name: "collectionStatistics",
  components: {XTable},
  computed: {
    ...mapGetters(['contractType']),
  },
  data() {
    // 示例用法
    const date = getFirstAndLastDayOfMonth();
    return {
      param: {
        date: date,
        queryCode: '',
        shopid: '', // 部门id
        departmentname: '', // 部门名称
        signer: '', // 签约人
        residentialAreaId: '', // 房源地址
        residentialAreaName: '', // 房源地址
      },
      columns: [
        { label: '日期', prop: 'signDate' },
        { label: '合同编号', render: 'contractCode' },
        { label: '部门', prop: 'departmentName', 'showOverflowTooltip': true, width: '200px' },
        { label: '签约人', prop: 'signer' },
        { label: '业主姓名', prop: 'ownerName' },
        { label: '客户姓名', prop: 'customerName' },
        { label: '房源地址', prop: 'houseAddr', 'showOverflowTooltip': true, width: '200px' },
        // { label: '房源编号', render: 'houseCode' },
        // { label: '客源编号', render: 'cusCode' },
        // { label: '应收(元)', prop: 'commission' },
        // { label: '实收(元)', prop: 'actualCommission' },
        { label: '应收/实收佣金(元)', prop: 'num1', width: "140px" },
        { label: '业主应收/实收(元)', prop: 'num2', width: "140px" },
        { label: '客户应收/实收(元)', prop: 'num3', width: "140px" },
        { label: '手续费应收/实收(元)', prop: 'num4', width: "140px" },
        { label: '优惠金额(元)', prop: 'discountMoney', width: "105px"  },
        { label: '未收(元)', prop: 'uncollected' },
      ],
      departmentList: [],
      userList: [],
      departpopshow: false,
      List: [],
      fields: {
        '日期': 'signDate',
        '合同编号': 'contractCode',
        '部门': 'departmentName',
        '签约人': 'signer',
        '业主姓名': 'ownerName',
        '客户姓名': 'customerName',
        '房源地址': 'houseAddr',
        '应收/实收佣金': 'num1',
        '业主应收/实收': 'num2',
        '客户应收/实收': 'num3',
        '手续费应收/实收': 'num4',
        // '房源编号': 'houseCode',
        // '客源编号': 'cusCode',
        // '应收(元)': 'commission',
        // '实收(元)': 'actualCommission',
        '优惠金额(元)': 'discountMoney',
        '未收(元)': 'uncollected',
      },
      excelName: '应收实收统计',
    }
  },
  methods: {
    getTableData(pages) {
      let date = this.param.date || [];
      if (date.length) {
        date = [
            date[0].toLocaleString().split(' ')[0].replace(/\//g, '-'),
            date[1].toLocaleString().split(' ')[0].replace(/\//g, '-'),
        ]
      }
      return this.$post(queryCollectedStatistics, {
        'page.pageNumber': (pages.current - 1) * pages.size,
        'page.pageSize': pages.size,
        ...this.param,
        date,
      }).then(res => {
        if (res.data && res.data.length) {
          const total = {
            commission: 0,
            actualCommission: 0,
            sellerCommission: 0,
            sellReceiveAmount: 0,
            buyerCommission: 0,
            buyReceiveAmount: 0,
            loanProcedures: 0,
            receiveLoanProcedures: 0,
            discountMoney: 0,
            uncollected: 0,
          };
          res.data.forEach(item => {
            item.num1 = fix(item.commission, item.actualCommission);
            item.num2 = fix(item.sellerCommission, item.sellReceiveAmount);
            item.num3 = fix(item.buyerCommission, item.buyReceiveAmount);
            item.num4 = fix(item.loanProcedures, item.receiveLoanProcedures);
            total.commission += item.commission;
            total.actualCommission += item.actualCommission;
            total.sellerCommission += item.sellerCommission;
            total.sellReceiveAmount += item.sellReceiveAmount;
            total.buyerCommission += item.buyerCommission;
            total.buyReceiveAmount += item.buyReceiveAmount;
            total.loanProcedures += item.loanProcedures;
            total.receiveLoanProcedures += item.receiveLoanProcedures;
            total.discountMoney += item.discountMoney;
            total.uncollected += item.uncollected;
          })
          this.List = res.data;
          res.data.push({
            signDate: '合计：',
            num1: fix(total.commission, total.actualCommission),
            num2: fix(total.sellerCommission, total.sellReceiveAmount),
            num3: fix(total.buyerCommission, total.buyReceiveAmount),
            num4: fix(total.loanProcedures, total.receiveLoanProcedures),
            discountMoney: total.discountMoney,
            uncollected: total.uncollected,
          })
        }
        return {
          total: res.total,
          records: res.data,
        }
      })
    },
    reload() {
      this.$refs.table.load(true)
    },
    // 查询部门
    getdepartmentFind() {
      this.$post(departmentFind).then(res => {
        if (res.success) {
          this.departmentList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    // 模糊查询小区
    querySearchAsync(queryString, cb) {
      // 查询小区
      let params = {
        name: queryString,
      };
      this.$post(communitynameQuery, params).then((res) => {
        if (res.success) {
          this.housingData = res.data;
          let restaurants = this.housingData;
          cb(restaurants);
        }
      });
    },
    handleSelect(item) {
      this.param.residentialAreaId = item.residentialAreaId + '';
      this.param.residentialAreaName = item.name;
      this.reload()
    },
    clearArea() {
      this.param.residentialAreaId = '';
      this.param.residentialAreaName = '';
      this.reload()
    },
    cellClassName({column}) {
      const property = column.property;
      if (["commission", 'actualCommission', 'uncollected'].includes(property)) {
        return 'red'
      }
      return '';
    },
    // 合同详情
    gotodetail(row) {
      sessionStorage.setItem("contractId", row.contractId);
      sessionStorage.setItem("concractEmployeeId", row.signerId);
      sessionStorage.setItem("electronictype", row.contractType);
      // sessionStorage.setItem("contractStatus", row.status); // todo
      // sessionStorage.setItem("electronic", row.electtionContractId); // todo
      this.$router.push({ path: "/contractDetails" });
      sessionStorage.setItem("concractFrom", "contracdetails");
    },
    // 房间详情
    gotoHouseDetail(row, column, event) {
      sessionStorage.setItem("buildId", row.houseInfoId);
      sessionStorage.setItem("sellHousebuildId", row.houseInfoId);
      // sessionStorage.setItem("employeeId", row.employeeId);
      // sessionStorage.setItem("upDown", row.upDown);
      // sessionStorage.setItem("keyicon", row.keyId);
      // sessionStorage.setItem("picture", row.picture);
      // sessionStorage.setItem("source", row.source);
      this.$router.push({ path: "buildDetail" });
    },
    // 客源详情
    gotoCustomerDetail(row, column, event) {
      this.$router.push({ path: "/purchaseDetail" });
      localStorage.setItem("customerId", row.customerId);
      sessionStorage.setItem("employeeId", row.cusEmployeeId);
    },
    departmentnameClear() {
      this.param.shopid = '';
      this.param.departmentname = '';
      this.userList = [...this.AllUserList];
      this.reload();
    },
    //选择部门
    handleNodeClick(node) {
      this.param.signer = '';
      this.param.shopid = node.id;
      this.param.departmentname = node.name;
      this.departpopshow = false;
      this.reload();
      this.getUserList()
    },
    getUserList() {
      const params = {
        "page.pageNumber": 1,
        "page.pageSize": 1000,
        departmentId: this.param.shopid,
      };
      this.$post(employeeQuery, params).then(res => {
        if (res.success === true) {
          this.userList = res.data;
          if (!this.param.shopid) {
            this.AllUserList = [...res.data]
          }
        }
      });
    },
  },
  mounted() {
    this.getdepartmentFind();
    console.log(JSON.parse(JSON.stringify(this.contractType)));
  },
}
</script>

<template>
<div class="collectionStatistics">
  <ul class="jobs_list">
    <li class="jobs_item">
      <span class="title-dec">签约日期：</span>
      <el-date-picker
          v-model="param.date"
          @change="reload"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
      </el-date-picker>
    </li>
    <li class="jobs_item">
      <span class="title-dec">编号：</span>
      <el-input @input="reload" placeholder="合同、客源、房源编号" v-model="param.queryCode" size="mini"/>
    </li>
    <li class="jobs_item conditions_list_item">
      <span class="title-dec">签约人：</span>
<!--      <el-cascader-->
<!--          v-model="param.shopid"-->
<!--          :options="departmentList"-->
<!--          @change="handleNodeClick"-->
<!--          size="mini"-->
<!--     />-->
      <el-input
          v-model="param.departmentname"
          @focus="departpopshow=!departpopshow"
          placeholder="请选择"
          clearable
          @clear="departmentnameClear"
          style="width: 160px;"
          size="mini"
      />
      <div class="departpop" v-show="departpopshow">
        <el-tree
            :default-expand-all="true"
            :data="departmentList"
            :props='{ children: "child"}'
            @node-click="handleNodeClick"
        >
              <span class="custom-tree-node" slot-scope="{data}">
                <div>
                  <img class="tree-icon" v-if="data.labelName==='区'" src="../../assets/icon/quyu.png" alt />
                  <img class="tree-icon" v-if="data.labelName==='店'" src="../../assets/icon/dian.png" alt />
                  <img class="tree-icon" v-if="data.labelName==='组'" src="../../assets/icon/zu.png" alt />
                  <span>{{ data.name }}</span>
                </div>
              </span>
        </el-tree>
      </div>
      <el-select
          v-model="param.signer"
          placeholder="请选择"
          size="mini"
          style="width: 110px;"
          @change="reload"
          clearable
      >
        <el-option
            v-for="item in userList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </li>
    <li class="jobs_item">
      <span class="title-dec">小区：</span>
      <el-autocomplete
          size="mini"
          popper-class="my-autocomplete"
          v-model="param.residentialAreaName"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入小区"
          @select="handleSelect"
          @clear="clearArea"
          clearable
      >
        <template slot-scope="{ item }">
          <div class="name">{{ item.name }}</div>
        </template>
      </el-autocomplete>
    </li>
    <li class="jobs_item">
      <span class="title-dec">合同类型：</span>
      <el-select class="short" v-model="param.contractType" placeholder="请选择" @change="reload" clearable size="mini">
        <el-option v-for="(item,index) in contractType" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
      </el-select>
    </li>
    <li style="margin-left: auto;">
      <download-excel class="export-excel-wrapper" :data="List" :fields="fields" :name="excelName">
        <el-button type="primary" style="background:#5E75E6;" size="mini">导出</el-button>
      </download-excel>
    </li>
  </ul>
  <XTable
      class="xtable"
      :data="getTableData"
      :columns="columns"
      ref="table"
      :table="{ headerCellStyle: ()=>'background-color: #F2F4FF', border: true, cellClassName: cellClassName  }"
      showPage
      :page="{pageSize: 20}"
      firstRendder
      show-all-btn
  >
    <template v-slot:contractCode="{row, $index}">
      <span
          style="cursor: pointer;color: #5E75E6"
          @click="gotodetail(row)"
      >
        {{row.contractCode}}
      </span>
    </template>
    <template v-slot:houseCode="{row, $index}">
      <span
          style="cursor: pointer;color: #5E75E6"
          @click="gotoHouseDetail(row)"
      >
        {{row.houseCode}}
      </span>
    </template>
    <template v-slot:cusCode="{row, $index}">
      <span
          style="cursor: pointer;color: #5E75E6"
          @click="gotoCustomerDetail(row)"
      >
        {{row.cusCode}}
      </span>
    </template>
  </XTable>
</div>
</template>

<style scoped lang="less">
.jobs_list {
  display: flex;
  justify-content: flex-start;
  margin: 15px;
  .jobs_item {
    display: flex;
    align-items: center;
    margin-right: 15px;
    .title-dec {
      white-space: nowrap;
    }
  }
  .el-input__inner {
    width: 170px;
    height: 30px;
    border-radius: 0;
    border: 1px solid #ccc;
    padding-right: 5px;
  }
  .el-date-editor {
    width: 250px;
  }
}
.x-table {
  /deep/ .red {
    color: red;
  }
  /deep/ tbody tr:last-child td {
    border: none;
    color: red;
  }
}
.conditions_list_item {
  position: relative;
}
.departpop {
  width: 160px;
  position: absolute;
  left: 64px;
  top: 41px;
  z-index: 10;
  border: 1px solid #eee;
  font-size: 14px;
  .el-tree {
    padding: 5px 0;
    .tree-item {
      display: flex;
      align-items: center;
      img {
        padding-right: 10px;
      }
    }
  }
}
</style>
